import {
  ActivityLogListQueryVariables,
  ModelType,
  QueryActivityLogsOrderByColumn,
  QueryActivityLogsWhereColumn,
  SortOrder,
} from "@/gql/graphql";

export function getActivityLogFeedQueryVariables(
  modelId: string,
  modelType: ModelType,
  variables?: Partial<ActivityLogListQueryVariables>,
): ActivityLogListQueryVariables {
  return {
    first: 20,
    where: {
      AND: [
        {
          column: QueryActivityLogsWhereColumn.SubjectId,
          value: modelId,
        },
        {
          column: QueryActivityLogsWhereColumn.SubjectType,
          value: modelType,
        },
      ],
    },
    orderBy: [
      {
        order: SortOrder.Desc,
        column: QueryActivityLogsOrderByColumn.CreatedAt,
      },
    ],
    ...variables,
  };
}
